import React from "react";

const LinkBoldIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      {...props}
    >
      <path
        d="M2.5 2.5C2.5 2.22386 2.72386 2 3 2H6.5C6.77614 2 7 1.77614 7 1.5C7 1.22386 6.77614 1 6.5 1H3C2.17157 1 1.5 1.67157 1.5 2.5V9.5C1.5 10.3284 2.17157 11 3 11H10C10.8284 11 11.5 10.3284 11.5 9.5V6C11.5 5.72386 11.2761 5.5 11 5.5C10.7239 5.5 10.5 5.72386 10.5 6V9.5C10.5 9.77614 10.2761 10 10 10H3C2.72386 10 2.5 9.77614 2.5 9.5V2.5Z"
        fill="#070B12"
      />
      <path
        d="M8 1.5C8 1.22386 8.22386 1 8.5 1H10.5C11.0523 1 11.5 1.44772 11.5 2V4C11.5 4.27614 11.2761 4.5 11 4.5C10.7239 4.5 10.5 4.27614 10.5 4V2.70711L6.85355 6.35355C6.65829 6.54882 6.34171 6.54882 6.14645 6.35355C5.95118 6.15829 5.95118 5.84171 6.14645 5.64645L9.79289 2H8.5C8.22386 2 8 1.77614 8 1.5Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default LinkBoldIcon;
